export class TipoNovedadEncabezadoDTO {
  id:string;
  descripcion:string;
  descripcionNovedadTipo: string;
}
